// The contract between creature *state* (derived from musical time + project state, see
// creatureState.ts) and creature *drawing* (ProceduralCreature). Pure data, no Pixi.

export type CreatureState = "idle" | "anticipate" | "hit" | "accent" | "hold" | "sleep" | "cheer" | "shush";

export type AccessoryKind = "none" | "top_hat" | "beanie" | "scarf" | "glasses" | "bow" | "crown";

export interface CreaturePose {
  state: CreatureState;
  /** 0..1 progress within the current state (hit decay, windup, cheer wave...). */
  phase: number;
  /** Squash-and-stretch: +1 = fully squashed (wide/short), -1 = fully stretched (tall/thin). */
  squash: number;
  /** Jump height as a fraction of body height (0..~1.2). */
  jump: number;
  /** Spin in radians (accents spin a full turn). */
  spin: number;
  /** Lean from pan, -1 (left) .. 1 (right). */
  lean: number;
  /** Overall size multiplier from pitch (higher pitch = smaller), ~0.7..1.25. */
  scale: number;
  /** Hue rotation in degrees from pitch. */
  hueShift: number;
  /** 0..1 mouth openness (hold keeps it open). */
  mouthOpen: number;
  /** 0..1 glow (Glimmers while holding / hit). */
  glow: number;
  /** 0..1 ripple amount (Wobblers while holding). */
  ripple: number;
  /** -1..1 breathing cycle synced to BPM. */
  breath: number;
  /** 0..1 eyelids closed (blink or sleep). */
  blink: number;
  /** -1..1 idle bob following the swing feel. */
  bob: number;
  /** 0..1 dimming (another creature is soloed). */
  dim: number;
  /** This creature is soloed: draw a spotlight. */
  spotlight: boolean;
  /** 0..1 flinch (a choke-group mate just fired and shushed us). */
  flinch: number;
  /** Seconds since state change, for secondary animation (Zzz bubbles, claps). */
  t: number;
}

export function restPose(): CreaturePose {
  return {
    state: "idle",
    phase: 0,
    squash: 0,
    jump: 0,
    spin: 0,
    lean: 0,
    scale: 1,
    hueShift: 0,
    mouthOpen: 0,
    glow: 0,
    ripple: 0,
    breath: 0,
    blink: 0,
    bob: 0,
    dim: 0,
    spotlight: false,
    flinch: 0,
    t: 0,
  };
}
